import { Button } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useToken } from '@app/hooks';

import styles from './styles.module.scss';

const MobileBottomNav = () => {
  const { t } = useTranslation('Nav');
  const { logout } = useToken();

  return (
    <div className={styles.buttonCenter}>
      <Button data-cy="mobileSignOut" onClick={logout} variant="secondary">
        {t('SignOut')}
      </Button>
    </div>
  );
};

export default MobileBottomNav;
